export const checkIsUserPhoneDeactivated = ({ userProfile }) =>
  userProfile && !userProfile.phone;
